import Http from "./http";

export const createAdminAPI = (data) => {
  return Http.post("admin/manage/create", data);
};

export const getAdminListAPI = (data) => {
  return Http.post("admin/manage/list", data);
};

export const getAdminPermissionsAPI = (data = {}) => {
  return Http.post("admin/manage/permissions", data);
};

export const updateAdminAPI = (data) => {
  return Http.post("admin/manage/update", data);
};
